import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NodeDialogInf} from '../../../nodes/nodes-dialog/nodes-dialog.component';

@Component({
  selector: 'import-node-from-topology-dialog',
  templateUrl: './import-node-from-topology-dialog.component.html',
  styleUrls: ['./import-node-from-topology-dialog.component.scss']
})
export class ImportNodeFromTopologyDialogComponent implements OnInit {

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  isAuthorized: boolean;

  constructor(public dialogRef: MatDialogRef<NodeDialogInf>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data.selectedNodes);
  }
}
